import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import qr from '../assets/qr.png';

export default function Give() {
  const [details, setDetails] = useState({
    upi_id: 'zionag.ooty@upi',
    account_name: 'Zion Assemblies of God Church',
    account_number: 'Contact church office',
    ifsc_code: 'Contact church office',
    bank_name: 'Contact church office',
    branch_name: 'Ooty, Tamil Nadu',
  });

  const [upiEnabled, setUpiEnabled] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase.from('give_details').select('*').single();
      if (data) setDetails(data);
      // Check if UPI is enabled
      const { data: settings } = await supabase.from('church_settings').select('value').eq('key','give_upi_enabled').single();
      if (settings) setUpiEnabled(settings.value !== 'false');
    };
    fetch();
  }, []);

  return (
    <section id="give" className="section" style={{ background: 'var(--bg-deep)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Partner With Us</span>
          <h2 className="section-title">Give to <span>God's Work</span></h2>
          <div className="divider center" />
          <p style={{ fontFamily: "'Crimson Pro',serif", fontSize: '1.05rem', color: 'var(--text-muted)', maxWidth: 580, margin: '0 auto 44px', lineHeight: 1.7 }}>
            Your generous giving supports the Gospel, helps the needy, and expands God's kingdom across the Nilgiris.
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 28, maxWidth: 880, margin: '0 auto' }}>
          {/* UPI */}
          <div className="card fade-up" style={{ padding: '36px 28px', textAlign: 'center' }}>
            <h3 style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '1rem', color: 'var(--primary)', marginBottom: 24 }}>📱 UPI Payment</h3>
            {!upiEnabled ? (
              <div style={{ padding:'32px 20px', textAlign:'center' }}>
                <div style={{ fontSize:'3rem', marginBottom:16 }}>🙏</div>
                <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.82rem', color:'var(--primary)', marginBottom:10 }}>Coming Soon</div>
                <p style={{ fontFamily:"'Crimson Pro',serif", fontSize:'1rem', color:'var(--text-muted)', lineHeight:1.7 }}>UPI payment will be available shortly. Please use bank transfer in the meantime.</p>
              </div>
            ) : (<>
            <div style={{ width: 185, height: 185, margin: '0 auto 18px', borderRadius: 14, overflow: 'hidden', border: '3px solid var(--primary)', boxShadow: '0 0 28px rgba(201,168,76,0.3)', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={qr} alt="UPI QR" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
            <div style={{ fontFamily: "'Crimson Pro',serif", fontSize: '1rem', color: '#f0e8d8', marginBottom: 8 }}>
              UPI ID: <strong style={{ color: 'var(--primary)' }}>{details.upi_id}</strong>
            </div>
            <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', lineHeight: 1.6 }}>Scan with Google Pay, PhonePe, Paytm or BHIM</p>
            </>)}
          </div>
          {/* Bank */}
          <div className="card fade-up" style={{ padding: '36px 28px' }}>
            <h3 style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '1rem', color: 'var(--primary)', marginBottom: 24, textAlign: 'center' }}>🏦 Bank Transfer</h3>
            {[
              ['Account Name', details.account_name],
              ['Account Number', details.account_number],
              ['IFSC Code', details.ifsc_code],
              ['Bank', details.bank_name],
              ['Branch', details.branch_name],
            ].map(([k, v]) => (
              <div key={k} style={{ marginBottom: 12, paddingBottom: 12, borderBottom: '1px solid rgba(201,168,76,0.1)', display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                <span style={{ fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--text-muted)', flexShrink: 0 }}>{k}</span>
                <span style={{ fontSize: '0.88rem', color: '#f0e8d8', fontWeight: 600, textAlign: 'right' }}>{v}</span>
              </div>
            ))}
            <blockquote style={{ fontFamily: "'Crimson Pro',serif", fontStyle: 'italic', fontSize: '0.95rem', color: 'var(--primary-light)', borderLeft: '3px solid var(--primary)', paddingLeft: 14, marginTop: 20, lineHeight: 1.6 }}>
              "God loves a cheerful giver." — 2 Corinthians 9:7
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}
